import * as React from 'react';

import EnterpriseExploreMenuItem from 'bundles/composable-page-header-enterprise/components/mobile/EnterpriseExploreMenuItem';
import EnterpriseExploreSubmenuWrapper from 'bundles/composable-page-header-enterprise/components/mobile/EnterpriseExploreSubmenuWrapper';
import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import GetAppMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/GetAppMenuItem';
import MetaNavMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MetaNavMenuItem';
import MobileFooterCtaContainer from 'bundles/composable-page-header/components/mobile-menu-items/MobileFooterCtaContainer';
import { MOBILE_EXPLORE_IDENTIFIER, MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';

export type DefaultLoggedOutWesMobileMenuConfigProps = {
  hideMetaNav?: boolean;
  renderLoggedOutCtas?: (isMobile?: boolean) => React.ReactNode;
};
function DefaultLoggedOutWesMobileMenuConfig(props: DefaultLoggedOutWesMobileMenuConfigProps) {
  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU]: (
          <EnterpriseExploreSubmenuWrapper
            identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_CATEGORIES_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_SKILLS_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_PROGRAM]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_PROGRAM_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_ORGANIZATION]: (
          <EnterpriseExploreSubmenuWrapper
            identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_ORGANIZATION_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_MORE]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_MORE_SUBMENU} />
        ),
      }}
    >
      <EnterpriseExploreMenuItem />
      {!props.hideMetaNav && <MetaNavMenuItem />}
      <GetAppMenuItem />
      {props.renderLoggedOutCtas ? (
        <MobileFooterCtaContainer>{props.renderLoggedOutCtas(true)}</MobileFooterCtaContainer>
      ) : null}
    </MobileMenuConfigWrapper>
  );
}

export default DefaultLoggedOutWesMobileMenuConfig;
